var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5381 0.792796C10.8281 0.53912 11.1021 0.53912 11.3599 0.792796L21.4629 10.7813C21.7529 11.035 21.7529 11.2887 21.4629 11.5423L11.3599 21.5309C11.1021 21.7846 10.8281 21.7846 10.5381 21.5309L9.57129 20.5795C9.4746 20.4844 9.42627 20.3576 9.42627 20.1991C9.42627 20.0405 9.4746 19.8978 9.57129 19.771L17.064 12.3985H0.580078C0.193359 12.3985 0 12.2082 0 11.8277V10.4959C0 10.1154 0.193359 9.92515 0.580078 9.92515H17.064L9.57129 2.55268C9.31348 2.26729 9.31348 1.99776 9.57129 1.74408L10.5381 0.792796Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame3);
export default __webpack_public_path__ + "static/media/Frame3.663664b7af2e1b5507f9404733ec2e23.svg";
export { ForwardRef as ReactComponent };